import SuccessIcon from '../assets/bridge-status-icons/success.svg';
import FailedIcon from '../assets/bridge-status-icons/failed.svg';
import PendingIcon from '../assets/bridge-status-icons/pending.svg';
import RefundIcon from '../assets/bridge-status-icons/refund.svg';

import { TransactionStatusEnum } from '../swagger/apexBridgeApiService';

const STATUS_TEXT: { [key: string]: string } = {
	[TransactionStatusEnum.Pending]: 'Pending',
	[TransactionStatusEnum.DiscoveredOnSource]: 'Discovered on source',
	[TransactionStatusEnum.InvalidRequest]: 'Invalid request',
	[TransactionStatusEnum.SubmittedToBridge]: 'Submitted to bridge',
	[TransactionStatusEnum.IncludedInBatch]: 'Included in batch',
	[TransactionStatusEnum.SubmittedToDestination]: 'Submitted to destination',
	[TransactionStatusEnum.FailedToExecuteOnDestination]:
		'Failed to execute on destination',
	[TransactionStatusEnum.ExecutedOnDestination]: 'Executed on destination',
};

const NOT_FINAL_STATES: { [key: string]: boolean } = [
	TransactionStatusEnum.Pending,
	TransactionStatusEnum.DiscoveredOnSource,
	TransactionStatusEnum.SubmittedToBridge,
	TransactionStatusEnum.IncludedInBatch,
	TransactionStatusEnum.SubmittedToDestination,
	TransactionStatusEnum.FailedToExecuteOnDestination,
].reduce((acc, cv) => ({ ...acc, [cv]: true }), {});

export function getStatusColor(status: TransactionStatusEnum) {
	switch (status) {
		case TransactionStatusEnum.InvalidRequest:
			return 'red';
		case TransactionStatusEnum.ExecutedOnDestination:
			return 'green';
		default:
			return 'none';
	}
}

// returns src for image to be used, as well as the message to show
export const getStatusIconAndLabel = (
	status: TransactionStatusEnum,
	isRefund: boolean,
) => {
	const finalStatuses = [
		TransactionStatusEnum.ExecutedOnDestination,
		TransactionStatusEnum.InvalidRequest,
	];

	if (isRefund) {
		if (status === TransactionStatusEnum.ExecutedOnDestination) {
			return { icon: RefundIcon, label: 'refunded' };
		}
		if (!finalStatuses.includes(status)) {
			return { icon: RefundIcon, label: 'refunding' };
		}
	}

	switch (status) {
		case TransactionStatusEnum.ExecutedOnDestination:
			return { icon: SuccessIcon, label: 'success' };
		case TransactionStatusEnum.InvalidRequest:
			return { icon: FailedIcon, label: 'failed' };
		case TransactionStatusEnum.Pending:
		case TransactionStatusEnum.DiscoveredOnSource:
		case TransactionStatusEnum.SubmittedToBridge:
		case TransactionStatusEnum.IncludedInBatch:
		case TransactionStatusEnum.SubmittedToDestination:
		case TransactionStatusEnum.FailedToExecuteOnDestination:
			return { icon: PendingIcon, label: 'pending' };
		default:
			return { icon: null, label: status };
	}
};

export function getStatusText(status: TransactionStatusEnum | string) {
	return STATUS_TEXT[status] || status;
}

export function isStatusFinal(status: TransactionStatusEnum) {
	return !NOT_FINAL_STATES[status];
}

export type SubmitLoadingState = {
	content: string;
	txHash: string | undefined;
};

export type UpdateSubmitLoadingState = {
	content?: string;
	txHash?: string;
};
